import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

const LoadingIndicator = ({ children, level, rowKey }) =>
  children &&
  <tr key={`loading-${rowKey}`} className="loading">
    <td className={classNames(`level-${level}`)}>
      {children}
    </td>
  </tr>;

LoadingIndicator.propTypes = {
  children: PropTypes.node,
  level: PropTypes.number,
  rowKey: PropTypes.string,
};

LoadingIndicator.defaultProps = {
  children: null,
  level: 0,
  rowKey: '0',
};

export default LoadingIndicator;
